
const VerifyStatus = {
  bankAccountClass(security) {
    const map = {
      review: 'badge-warning',
      pending: 'badge-warning',
      approved: 'badge-success',
      hold: 'badge-danger'
    }
    return 'badge ' + map[security]
  },
  userClass(security) {
    const map = {
      nobody: 'badge-warning',
      verified: 'badge-info',
      approved: 'badge-success'
    }
    return 'badge ' + map[security]
  }

}

export default VerifyStatus